export const routes = {
  home: '/',
  saerch: '/search',
  listing: '/listing',
  vehicleDetail: '/vehicle-addons',
  customerInformation: '/customer-information',
  paymentOption: '/payment-option',
};
